import { useRef, useEffect, RefObject } from 'react'

interface UseClickOutsideOptions {
    enabled?: boolean
    eventType?: 'mousedown' | 'click' | 'touchstart'
}

const useClickOutside = <T extends HTMLElement = HTMLElement>(
    callback: () => void,
    options: UseClickOutsideOptions = {}
): RefObject<T> => {
    const { enabled = true, eventType = 'mousedown' } = options
    const ref = useRef<T>(null)

    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callback()
            }
        }

        if (enabled) {
            document.addEventListener(eventType, handleClickOutside)
        }

        return () => {
            document.removeEventListener(eventType, handleClickOutside)
        }
    }, [callback, enabled, eventType])

    return ref
}

export default useClickOutside
